import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SplitPipe } from '../../pipes/split.pipe';
import { TagsPipe } from '../../pipes/tags.pipe';


@Component({
   selector: 'app-tags',
   imports: [CommonModule, MatDialogModule, MatIcon, SplitPipe, TagsPipe],
   standalone: true,
   templateUrl: './tags.component.html',
   styleUrls: ['./tags.component.scss']
})
export class TagsComponent {
   @Input() tags: string = '';

}
